import React, { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useSectionsUIContext } from "../SectionsUIContext";
import { CustomSelect, FilterOptions, SectionAttendanceStatusOptions } from "../../../../../../../_helpers/Helpers";

const prepareFilter = (queryParams, values) => {
  let { date, section, teacherId, attendanceStatus } = values;
  const newQueryParams = { ...queryParams };
  const filter = { date, section, teacherId, attendanceStatus };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SectionsFilter({
  date
}) {
  // Sections UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      setQueryParams: sectionsUIContext.setQueryParams,
      queryParams: sectionsUIContext.queryParams,
    };
  }, [sectionsUIContext]);
  
  const { teachers } = useSelector(
    (state) => ({
      teachers: state.attendance.teachers
    }),
    shallowEqual
  );

  useEffect(() => {
    applyFilter({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  const applyFilter = (values) => {
    values.date = date;
    const newQueryParams = prepareFilter(sectionsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, sectionsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      sectionsUIProps.setQueryParams(newQueryParams);
    }
  };

  const teacherOptions = FilterOptions.concat(teachers);
  const attendanceStatusOptions = FilterOptions.concat(SectionAttendanceStatusOptions);

  return (
    <Formik
      initialValues={{
        section: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="section"
                placeholder="Sınıf"
                onBlur={handleBlur}
                value={values.section}
                onChange={(e) => {
                  setFieldValue("section", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={teacherOptions}
                value={values.teacherId}
                placeholder="Öğretmen"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("teacherId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğretmen</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={attendanceStatusOptions}
                value={values.attendanceStatus}
                placeholder="Yoklama Durumu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("attendanceStatus", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Yoklama Durumu</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}